import axios from 'axios'
import * as types from './types'

export const actions = {
    // Work Processes Actions
    fetchWorkProcesses({commit}, {page = 1, perPage = 10, orderId = null, isOrderPage = null, paginate = true, fetchAvailable = false}) {
        commit(types.SET_LOADING, true);


        const url = '/work-processes';
        const params = {
            paginate,
            page,
            per_page: perPage,
            ...(orderId && {orderId}) // Include orderId only if it's truthy
        };

        return axios
            .get(url, {params})
            .then(response => {
                const data = response.data?.data || [];
                const totalPages = response.data?.meta?.total_pages || 0;

                if (fetchAvailable) {
                    commit(types.SET_WORK_PROCESSES_AVAILABLE, {
                        workProcessesAvailable: data.map((process) => ({
                            value: process.id,
                            label: process.name,
                        })),
                        totalPagesAvailable: totalPages
                    });
                } else if (!orderId  && isOrderPage) {
                    commit(types.SET_WORK_PROCESSES, {
                        workProcesses: [],
                        totalPages: 0
                    });
                } else {
                    commit(types.SET_WORK_PROCESSES, {
                        workProcesses: data,
                        totalPages
                    });
                }

                return response.data;
            })
            .catch(error => {
                console.error('Failed to fetch work processes:', error); // Log the error for debugging
                commit(types.SET_ERROR, 'Failed to fetch work processes'); // Handle the error state
                throw error; // Allow the caller to handle it further
            })
            .finally(() => {
                commit(types.SET_LOADING, false);
            });
    },


    toggleTaskCompleted(_, {taskId, workProcessId}) {
        return axios.post(`/work-processes/${workProcessId}/tasks/${taskId}/toggle-completed`);
    },


    attachWorkProcessToOrder(_, {orderId, workProcessId}) {
        return axios.post(`/work-processes/${workProcessId}/attach-to-order/${orderId}`);
    },


    detachWorkProcessFromOrder(_, {orderId, workProcessId}) {
        return axios.post(`/work-processes/${workProcessId}/detach-from-order/${orderId}`);
    },

    createWorkProcess({commit}, {workProcess, orderId = null}) {
        commit(types.SET_LOADING, true)
        // console.log(workProcess);
        return axios.post('/work-processes', {workProcess, orderId})
            .then(response => {
                commit(types.ADD_WORK_PROCESS, response.data)
                return response.data.work_process
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to create work process')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    updateWorkProcess({commit}, {id, data, orderId}) {
        commit(types.SET_LOADING, true)

        console.log("Fetchi available???")
        return axios.put(`/work-processes/${id}`, data)
            .then(response => {
                commit(types.UPDATE_WORK_PROCESS, response.data)
                return response.data
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to update work process')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    deleteWorkProcess({commit}, id) {
        commit(types.SET_LOADING, true)
        return axios.delete(`/work-processes/${id}`)
            .then(() => {
                commit(types.DELETE_WORK_PROCESS, id)
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to delete work process')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    duplicateWorkProcess({commit, dispatch}, id) {
        commit(types.SET_LOADING, true)
        return axios.post(`/work-processes/${id}/duplicate`)
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to duplicate work process')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    toggleItemDetails({commit, dispatch}, item) {
        const newDetailsValue = !item._showDetails
        commit('SET_ITEM_DETAILS', {
            itemId: item.id,
            value: newDetailsValue
        })

        if (newDetailsValue && (!item.tasks || !item.tasks.length)) {
            commit('SET_ITEM_LOADING', {
                itemId: item.id,
                value: true
            })

            return dispatch('fetchTasks', item.id)
                .then(tasks => {
                    commit('SET_ITEM_TASKS', {
                        itemId: item.id,
                        tasks
                    })
                })
                .finally(() => {
                    commit('SET_ITEM_LOADING', {
                        itemId: item.id,
                        value: false
                    })
                })
        }
        return Promise.resolve()
    },

    fetchTasks({commit}, workProcessId) {
        commit(types.SET_LOADING, true)
        return axios.get(`/work-processes/${workProcessId}/tasks`)
            .then(response => {
                commit(types.SET_TASKS, response.data)
                return response.data.tasks
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to fetch tasks')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    createTask({commit}, {workProcessId, task}) {
        commit(types.SET_LOADING, true)
        return axios.post(`/work-processes/${workProcessId}/tasks`, task)
            .then(response => {
                commit(types.ADD_TASK, response.data)
                return response.data
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to create task')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    updateTask({commit}, {workProcessId, taskId, data}) {
        commit(types.SET_LOADING, true)
        return axios.put(`/work-processes/${workProcessId}/tasks/${taskId}`, data)
            .then(response => {
                commit(types.UPDATE_TASK, response.data.tasks)
                return response.data
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to update task')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    deleteTask({commit}, {workProcessId, taskId}) {
        commit(types.SET_LOADING, true)
        return axios.delete(`/work-processes/${workProcessId}/tasks/${taskId}`)
            .then(() => {
                commit(types.DELETE_TASK, workProcessId, taskId)
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to delete task')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    duplicateTask({commit, dispatch}, {workProcessId, taskId}) {
        commit(types.SET_LOADING, true)
        return axios.post(`/work-processes/${workProcessId}/duplicate/${taskId}`)
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to duplicate task')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    fetchVehicleModels({commit}, search = '') {
        commit(types.SET_LOADING, true)
        return axios.get('/assets/search-models', {
            params: {search}
        })
            .then(response => {
                let vehicles = []
                if (response.data && Array.isArray(response.data.vehicle_models)) {
                    vehicles = response.data.vehicle_models
                }
                commit(types.SET_VEHICLE_MODELS, vehicles)
                return vehicles
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to fetch vehicle models')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    fetchUsers({commit}, {search = '', role = null}) {
        commit(types.SET_LOADING, true)
        return axios.get('/users', {
            params: {search, role}
        })
            .then(response => {
                commit(types.SET_USERS, response.data)
                return response.data
            })
            .catch(error => {
                commit(types.SET_ERROR, error.response?.data?.message || 'Failed to fetch users')
                throw error
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    },

    clearError({commit}) {
        commit(types.SET_ERROR, null)
    },

    setCurrentPage({ commit }, page) {
        commit(types.SET_CURRENT_PAGE, page);
    }
}
